<template>
  <div>
    <ve-table
      :fixed-header="false"
      max-height="calc(100vh - 11.4rem)"
      :columns="columns"
      :table-data="summary"
      :border-around="false"
    />
    <empty-state
      v-if="!isFetching && !summary.length"
      :title="$t('SEARCH.EMPTY_STATE')"
    />
    <div v-if="isFetching" class="loader">
      <spinner />
      <span>{{ $t('SEARCH.SEARCHING_STATE') }}</span>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import rtlMixin from 'shared/mixins/rtlMixin';

// Resumo da pesquisa da conta mãe: quantidade de resultados por subconta
export default {
  components: {
    VeTable,
    Spinner,
    EmptyState,
  },
  mixins: [rtlMixin],
  props: {
    summary: {
      type: Array,
      default: () => [],
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    columns() {
      return [
        {
          field: 'account',
          key: 'account',
          title: this.$t('SEARCH.LIST.HEADER.ACCOUNT'),
          align: this.isRTLView ? 'right' : 'left',
          width: 300,
          renderBodyCell: ({ row }) => row.title,
        },
        {
          field: 'total',
          key: 'total',
          title: this.$t('SEARCH.LIST.HEADER.TOTAL'),
          align: 'center',
          width: 200,
          renderBodyCell: ({ row }) => row.total,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}
</style>
